<template>
  <collapse-box :default-expand="true">
    <div id="product-comment" ref="comment" v-loading="loading">
      <!-- 标题 -->
      <div class="header">
        <div class="title">评价<span>（{{commentTotalTheme}}）</span></div>
      </div>

      <!-- 好评率 -->
      <div class="favorable-rate" v-if="favoritate">
        {{favoritate}}<span class="favorable-symbol">%</span><span class="favorable-text">好评率</span>
      </div>

      <div
        class="comment-tab"
      >
        <div class="comment-header">
          <div class="nav-box">
            <div
              class="nav-item"
              :class="{ active: commentActiveTab === 0 }"
              id="comment-nav-item-0"
              @click="commentTabSwitch(0)"
            >
              全部评价
            </div>
            <div
              class="nav-item"
              :class="{ active: commentActiveTab === 4 }"
              id="comment-nav-item-4"
              @click="commentTabSwitch(4)"
            >
              最新评价
            </div>
            <div
              class="nav-item"
              :class="{ active: commentActiveTab === 1 }"
              id="comment-nav-item-1"
              @click="commentTabSwitch(1)"
            >
              有图 <span>（{{haveImgComment}}）</span>
            </div>
            <div
              class="nav-item"
              :class="{ active: commentActiveTab === 2 }"
              id="comment-nav-item-2"
              @click="commentTabSwitch(2)"
            >
              好评 <span>（{{goodCommentCount}}）</span>
            </div>
            <div
              class="nav-item"
              :class="{ active: commentActiveTab === 3 }"
              id="comment-nav-item-3"
              @click="commentTabSwitch(3)"
            >
              中差评 <span>（{{negativeCommentCount}}）</span>
            </div>
          </div>
          <collapse-btn></collapse-btn>
        </div>
        <collapse-content>
          <div class="comment-content">
            <div
              class="comment-li"
              v-for="(item, index) in commentList"
              :key="index"
            >
              <div class="comment-li-left">
                <div class="user-avatar">
                  <img v-if="item.peer_info.logo" :src="item.peer_info.logo" alt="" />
                  <img v-else src="../../../../assets/imgs/comment/default-avatar.png" alt="" />
                </div>
                <div class="user-company">{{ item.peer_info.peer_name }}</div>
              </div>
              <div class="comment-li-right">
                <div class="comment-li-header">
                  <div class="comment-level">
                    <img :src="`https://o.666visa.cn/static/ssqpeer/product/rate${item.level}.png`" alt="" />
                    <div class="level-text">
                      {{ commentLevelMap[item.level] }}
                    </div>
                  </div>
                  <div class="comment-impression">
                    <div
                      class="comment-impression-li"
                      v-for="(tag, index) in item.order_review_label"
                      :key="index"
                    >
                      {{ tag.content }}
                    </div>
                  </div>
                </div>
                <div class="comment-li-text">
                  {{ item.content }}
                </div>
                <div class="comment-li-pic" v-if="item.order_review_pic_set && item.order_review_pic_set.length>0">
                  <img
                    class="comment-img"
                    :src="el"
                    alt=""
                    v-for="(el, index) in item.order_review_pic_set"
                    :key="index"
                    v-viewer
                  />
                </div>
                <div class="user-publish-date">
                  {{ item.create_time }} 发表于<span>{{
                    item.review_ip_province
                  }}</span>
                </div>
                <div v-if="item.reply_status === 1" class="comment-li-reply">回复：{{item.reply_content}}</div>
              </div>
            </div>
          </div>

          <!-- 常见问题列表翻页 -->
          <el-pagination
            class="comment-list-pagination"
            @size-change="getCommentList()"
            @current-change="getCommentList()"
            :current-page.sync="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            v-show="commentTotal > 20"
            :total="commentTotal"
          ></el-pagination>
        </collapse-content>
      </div>
      <!-- 没有问题 -->
      <div
        class="qa-no-comment"
        v-show="commentList && commentList.length === 0"
      >
        <img src="../../../../assets/imgs/comment/no-comment.png" alt="暂无回答" />
        <p>暂时还没有评价哦</p>
      </div>
    </div>
  </collapse-box>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import commentApi from '@/api/product-comment-api';
import CollapseBox from '../../../../components/common/collapse/collapse-box';
import CollapseBtn from '../../../../components/common/collapse/collapse-btn';
import CollapseContent from '../../../../components/common/collapse/collapse-content';
import { commentLevelMap } from '../../services/material-service';

export default {
  name: 'common-comments',
  components: {
    CollapseBox,
    CollapseBtn,
    CollapseContent,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    country: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      commentActiveTab: 0,
      commentLevelMap,
      currentPage: 1,
      isContainImg: undefined,
      commentList: [],
      commentTotalTheme: 0,
      favoritate: '',
      haveImgComment: 0,
      goodCommentCount: 0,
      negativeCommentCount: 0,
      commentData: {},
      loading: false,
    };
  },
  computed: {
    level_list() {
      if (this.commentActiveTab === 2) {
        return [1];
      } else if (this.commentActiveTab === 3) {
        return [2, 3];
      }
      return undefined;
    },
    is_contain_img() {
      if (this.commentActiveTab === 1) {
        return 1;
      }
      return undefined;
    },
    sort_type() {
      if (this.commentActiveTab === 4) {
        return 2;
      }
      return 1;
    },
    commentTotal() {
      if (this.commentActiveTab === 1) {
        return this.commentData.page_having_pictures_count;
      } else if (this.commentActiveTab === 2) {
        return this.commentData.page_positive_reviews_count;
      } else if (this.commentActiveTab === 3) {
        return this.commentData.page_not_positive_reviews_count;
      }
      return this.commentData.total_count;
    },
  },

  methods: {
    // 获取评论列表
    async getCommentList() {
      this.loading = true;
      try {
        const params = {
          product_id: this.product.visa_product_id,
          page: this.currentPage,
          level_list: this.level_list,
          is_contain_img: this.is_contain_img,
          sort_type: this.sort_type,
        };
        const data = await commentApi.getCommentList(params);
        this.favoritate = data.favorable_rating;
        this.commentList = data.page_data;
        this.commentTotalTheme = data.total_count;
        this.haveImgComment = data.page_having_pictures_count;
        this.goodCommentCount = data.page_positive_reviews_count;
        this.negativeCommentCount = data.page_not_positive_reviews_count;
        this.commentData = data;
      } catch (e) {
        this.commentList = [];
      } finally {
        this.loading = false;
      }
    },


    commentTabSwitch(index) {
      this.commentActiveTab = index;
      this.currentPage = 1;
      this.getCommentList();
    },
    // 获取评价模块的位置
    getCommentPosition() {
      const currentPosition = this.$refs.comment.getBoundingClientRect();
      if (currentPosition && currentPosition.top <= 350) {
        sensorsdata.track('Comment_expose', {
          product_id: this.product.visa_product_id,
        });
      }
    },
  },
  watch: {
    product(newVal) {
      if (newVal.visa_product_id) {
        this.commentTabSwitch(0);
        this.getCommentList();
      }
    },
  },
  mounted() {
    this.getCommentList();
    document.addEventListener('scroll', this.getCommentPosition());
  },
  // destroyed() {
  //   document.removeEventListener('scroll', this.getCommentPosition());
  // },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/less/variable";

#product-comment {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
  background: #fff;
  border-radius: 2px;
  margin-top: 12px;
  .header {
    padding: 16px;
    display: flex;
    align-items: center;
    .title {
      flex-grow: 1;
      color: #2f333d;
      font-size: 20px;
      font-weight: 600;
      position: relative;
      z-index: 1;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -2px;
        z-index: -1;
        width: 48px;
        height: 6px;
        background: linear-gradient(
          270deg,
          rgba(89, 159, 255, 0) 0%,
          rgba(89, 159, 255, 1) 100%
        );
        opacity: 0.6;
      }
    }
  }

  .favorable-rate {
    padding: 8px 16px 12px;
    font-size: 32px;
    font-weight: 600;
    color: #ff8033;
    line-height: 32px;
    .favorable-symbol {
      font-size: 20px;
      font-weight: 500;
      color: #ff8033;
      line-height: 20px;
    }
    .favorable-text {
      font-size: 12px;
      font-weight: 400;
      color: #2f333d;
      line-height: 12px;
      padding-left: 6px;
    }
  }

  .comment-tab {
    padding: 0;

    .comment-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 16px;
      border-bottom: 1px solid #e9eef2;
      .nav-box {
        height: 44px;
        display: flex;
        position: relative;
        padding: 0 16px;
        .nav-item {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #91999f;
          margin-right: 32px;
          cursor: pointer;
          position: relative;
          &.active {
            font-weight: 600;
            color: #599fff;
            &::after {
              content: "";
              width: 32px;
              height: 3px;
              background: linear-gradient(
                90deg,
                rgba(31, 136, 255, 1) 0%,
                rgba(138, 192, 255, 1) 100%
              );
              border-radius: 2px 2px 0px 0px;
              position: absolute;
              bottom: 0;
              transition: 0.15s all;
              left: 50%;
              transform: translate(-50%, 0);
            }
          }
        }
        .nav-bottom-bar {
          width: 32px;
          height: 3px;
          background: linear-gradient(
            90deg,
            rgba(31, 136, 255, 1) 0%,
            rgba(138, 192, 255, 1) 100%
          );
          border-radius: 2px 2px 0px 0px;
          position: absolute;
          bottom: 0;
          left: 0;
          transition: 0.15s all;
        }
      }
    }

    .comment-content {
      display: flex;
      flex-direction: column;
      .comment-li {
        padding: 16px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: flex-start;

        .comment-li-left {
          display: flex;
          flex-direction: column;
          padding: 4px 10px;
          width: 162px;
          margin-right: 80px;
          .user-avatar {
            display: block;
            width: 54px;
            height: 54px;
            margin: 0 auto 12px;
            border-radius: 50%;
            overflow: hidden;
            background: url('../../../../assets/imgs/comment/default-avatar.png') center no-repeat;
            background-size: cover;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .user-company {
            width: 100%;
            font-size: 14px;
            font-weight: 400;
            color: #2f333d;
            text-align: center;
          }
        }
        .comment-li-right {
          display: flex;
          flex-direction: column;
          flex: 1;
          .comment-li-header {
            display: flex;
            margin-bottom: 12px;
            .comment-level {
              display: flex;
              height: 20px;
              min-width: 60px;
              align-items: center;
              > img {
                display: inline-block;
                width: 20px;
                height: 20px;
                object-fit: contain;
              }
              .level-text {
                font-size: 16px;
                font-weight: 500;
                color: #599fff;
                padding-left: 6px;
                margin-top: 2px;
              }
            }
            .comment-impression {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              flex-wrap: wrap;
              row-gap: 12px;
              margin-left: 32px;
              .comment-impression-li {
                background: rgba(58, 165, 255, 0.08);
                border-radius: 17px;
                font-size: 14px;
                padding: 5px 22px;
                font-weight: 400;
                color: #599fff;
                margin: 0 12px 0 0;
              }
            }
          }
          .comment-li-text {
            font-size: 14px;
            color: #2f333d;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; // 控制多行的行数
            -webkit-box-orient: vertical;
          }
          .comment-li-pic {
            display: flex;
            flex-direction: row;
            margin-top: 12px;
            .comment-img {
              display: block;
              width: 56px;
              height: 56px;
              background: #ddd;
              margin-right: 16px;
              object-fit: contain;
              border-radius: 4px;
              &:hover{
                cursor: pointer;
              }
            }
          }
          .user-publish-date {
            width: 100%;
            font-size: 12px;
            color: #91999f;
            margin-top: 12px;
          }
          .comment-li-reply {
            margin: 12px 20px 0 0;
            background: #f3f6f9;
            padding: 20px;
            font-size: 12px;
            line-height: 20px;
            color: #333;
            border-radius: 4px;
          }
        }
      }
    }
    .comment-list-pagination {
      padding: 16px 0;
      display: flex;
      justify-content: center;
      color: #aaa;
    }
  }
  .qa-no-comment {
    margin: 50px auto 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    line-height: 54px;
    color: #6f6f6f;
    padding-bottom: 60px;
    img {
      width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/product-comment.vue